var map = {
	"./paint-brush-active.svg": 8756,
	"./paint-brush.svg": 84828,
	"./paint-circle.svg": 33632,
	"./paint-clear-active.svg": 33794,
	"./paint-clear-gray.svg": 81417,
	"./paint-clear.svg": 89563,
	"./paint-down.svg": 5720,
	"./paint-eraser-active.svg": 3975,
	"./paint-eraser-gray.svg": 94536,
	"./paint-eraser.svg": 61724,
	"./paint-muti.svg": 44891,
	"./paint-quit-active.svg": 71780,
	"./paint-quit.svg": 18233,
	"./paint-toggle.svg": 37560,
	"./paint-triangle.svg": 16792
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72922;